module.exports = __webpack_public_path__ + "img/activity14.c773cffc.jpg";